import { useCallback, useContext, useEffect, useState } from "react";
import { UnidentifiedCreationInfo } from "../../../generated/data-contracts";
import { IAxiosError, api } from "../../../utils";
import { AvisForm } from "../../shared/components";
import { AvisDescriptiveText } from "../../shared/components/form";
import { AvisContext } from "../../shared/context/AvisContext";
import { UnidentifiedCreationListGrid } from "./UnidentifiedCreationListGrid";

export function UnidentifiedCreationListPage() {
  const { res, ctxRightsHolder } = useContext(AvisContext);

  const [initGridData, setInitGridData] = useState<
    UnidentifiedCreationInfo[] | undefined
  >();
  const [isGridLoading, setIsGridLoading] = useState<boolean>(true);
  const [error, setError] = useState<IAxiosError>();

  const getGridData = useCallback(() => {
    if (!ctxRightsHolder?.rightsHolderId) return;
    setIsGridLoading(true);

    api
      .rightsHoldersGetUnidentifiedCreationList(ctxRightsHolder.rightsHolderId)
      .then((res) => setInitGridData(res.data))
      .catch(setError)
      .finally(() => {
        setIsGridLoading(false);
      });
  }, [ctxRightsHolder]);
  useEffect(() => {
    getGridData();
  }, [getGridData]);

  return (
    <AvisForm title={res("authors_UnidentifiedCreations_Title")}>
      <AvisDescriptiveText textKey="portal_RH_UnidentifiedCreations" />
      <UnidentifiedCreationListGrid
        initData={initGridData}
        loading={isGridLoading}
        error={error}
      />
    </AvisForm>
  );
}
